import {getFormattedTimeInterval} from './moment-date';

const ageRating = 3;

const ageFromDate = (birthday) => {
    let now = new Date();

    let age = now.getFullYear() - birthday.getFullYear();

    if (now.getMonth() < birthday.getMonth()) {
        age--;
    } else if (now.getMonth() === birthday.getMonth() && now.getDate() < birthday.getDate()) {
        age--;
    }
    return age;
};

const dateOfBirthValidator = (v, required = false) => {
    if (v && ageFromDate(v) < ageRating) {
        const now = new Date();
        const lowerBound = new Date(1900, 0, 1);
        const upperBound = now.setFullYear(now.getFullYear() - ageRating);
        return 'Дата рождения должна быть в диапазоне: '
            + getFormattedTimeInterval(
                lowerBound,
                upperBound,
                'DD.MM.YYYY'
            );
    }
    if (!v && required) return 'Укажите дату рождения';
    return null;
};

export default ageFromDate;
export { dateOfBirthValidator, ageRating };